import { Navigate, Outlet } from "react-router-dom";
import { getAccess } from "./utils/authUtils";

// Basic guard: if no token, send to login.
export default function ProtectedRoute() {
  const authed = Boolean(getAccess());
  return authed ? <Outlet /> : <Navigate to="/" replace />;
}